/**
 * @generated SignedSource<<8318f8b3e43756e3f1201e58c1b5ebff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProviderStartUploadMutation$variables = {
  datasetVersionId: string;
};
export type ProviderStartUploadMutation$data = {
  readonly startDatasetVersionUpload: {
    readonly id: string;
  };
};
export type ProviderStartUploadMutation = {
  response: ProviderStartUploadMutation$data;
  variables: ProviderStartUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "datasetVersionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "datasetVersionId",
        "variableName": "datasetVersionId"
      }
    ],
    "concreteType": "DatasetVersion",
    "kind": "LinkedField",
    "name": "startDatasetVersionUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderStartUploadMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ProviderStartUploadMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "34e04af2e2ab819a16b5383d38b5fe4e",
    "id": null,
    "metadata": {},
    "name": "ProviderStartUploadMutation",
    "operationKind": "mutation",
    "text": "mutation ProviderStartUploadMutation(\n  $datasetVersionId: ID!\n) {\n  startDatasetVersionUpload(datasetVersionId: $datasetVersionId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc83ced83ee1bde7a6f53be6612aaf55";

export default node;
